module.exports = __webpack_public_path__ + "141d4a85/img/delete-icon.eb7de062.svg";